'use client'

import { CONSENT_COOKIE } from 'cookies/constants'
import { useCookiesContext } from 'cookies/hooks/useCookiesContext'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useEffect } from 'react'
import { isBot } from 'utils/isBot/IsBot'

import { getCookie } from '../../utils/getCookies'
import { CookiesContent } from './CookiesContent'

export const CookiesBanner = () => {
	const { pageType } = useMasterData()
	const { show, setShow, setCookiesConsent, blockedPageTypes } =
		useCookiesContext()

	useEffect(() => {
		if (!!getCookie(CONSENT_COOKIE)) {
			setCookiesConsent(true)
			return
		}

		if (!blockedPageTypes.includes(pageType) && !isBot()) {
			setShow(true)
		}
	}, [])

	return show ? <CookiesContent /> : null
}
